import { render, staticRenderFns } from "./PromotionActivities.vue?vue&type=template&id=f435a998&scoped=true&"
import script from "./PromotionActivities.vue?vue&type=script&lang=js&"
export * from "./PromotionActivities.vue?vue&type=script&lang=js&"
import style0 from "./PromotionActivities.vue?vue&type=style&index=0&id=f435a998&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f435a998",
  null
  
)

export default component.exports